@if (!isLoading()) {
<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.NEW-CHAT.createANewBroadcastChannel' | translate | uppercase }}
</h1>

<div mat-dialog-content>
  <form [formGroup]="newChatForm">
    <mat-form-field appearance="fill" class="full-width-input">
      <input matInput placeholder="{{ 'NGX-MESSAGING.NEW-CHAT.broadcastName' | translate }}" formControlName="displayName" />
    </mat-form-field>
    <div class="sections-container">
      <div class="sections-container__tags">
        <ngx-tags
          [maxTagsListHeigt]="'30vh'"
          (tagsChangedEvent)="tagsChanged($event)"
          [tagsSelected]="tagsSelected"></ngx-tags>
      </div>
      <div class="sections-container__users">
        <ngx-users-search
          [useGroups]="true"
          [maxUsersListHeigt]="'35vh'"
          [showFilterInput]="true"
          [tagsFilter]="tagsSelected"
          [isLoadingAllCheck]="isLoadingTagsCheck()"
          [isLoadingUsers]="isLoadingTagsCheck()"
          [usersSelected]="usersSelected"
          (usersSelectedChange)="usersSelected = $event"></ngx-users-search>
      </div>
    </div>
    @if (usersSelected?.length) {
    <ngx-users-selected [usersSelected]="usersSelected" (usersSelectedChange)="usersSelected = $event"></ngx-users-selected>
    }
  </form>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="chat-input__button"
    color="primary"
    (click)="createChannel()"
    [disabled]="!newChatForm.valid || (!usersSelected.length && !tagsSelected.length)">
    {{ 'NGX-MESSAGING.NEW-CHAT.createBroadcast' | translate }}
  </button>
</div>
} @else {
<ngx-text-spinner [text]="'NGX-MESSAGING.NEW-CHAT.creatingBroadcast' | translate"></ngx-text-spinner>
}
